import { assert } from "../utilities/assert.js";
export function createExecutorMap(executors) {
    const executorForTypes = {};
    executors.forEach((executor) => {
        assert(executorForTypes[executor.type] === undefined, `Only one executor can be declared for given type '${executor.type}'`);
        executorForTypes[executor.type] = executor;
    });
    return executorForTypes;
}
//# sourceMappingURL=executor-map.js.map